import { Component, OnDestroy, OnInit } from "@angular/core";
import { PatientSearch, PatientView } from "src/app/model/patient";
import { IntegratedAdmissionWizardService } from "../service/integrated-admission-wizard.service";
import { PatientService } from "src/app/services/patient.service";
import { Subscription } from "rxjs";
import { PatientReservationMessageService } from "src/app/services/patient-reservation-message.service";

@Component({
  selector: "app-integrated-admission-patient",
  templateUrl: "./integrated-admission-patient.component.html",
  styleUrls: ["./integrated-admission-patient.component.css"],
})
export class IntegratedAdmissionPatientComponent implements OnInit, OnDestroy {
  patient: PatientSearch;
  patientView: PatientView;
  loading: boolean;
  readonly = false;
  readonlySubscription: Subscription;
  patientCellPhoneSubscription: Subscription;

  constructor(
    private patientReservationMessageService: PatientReservationMessageService,
    private service: IntegratedAdmissionWizardService,
    private patientService: PatientService,
  ) {}

  ngOnDestroy(): void {
    if (this.readonlySubscription) this.readonlySubscription.unsubscribe();
    if (this.patientCellPhoneSubscription)
      this.patientCellPhoneSubscription.unsubscribe();
  }

  async ngOnInit() {
    this.loading = true;
    if (this.service.patientId) {
      this.patientView = await this.patientService.getPatientView(
        this.service.patientId,
      );

      this.patientReservationMessageService.showReservationAlertIfRequired(
        this.service.patientId,
        this.service.showPreAdmissionPatientAppointment(),
        this.service.showPreAdmissionPatientAppointment() ? 7 : 0,
        this.service.showPreAdmissionPatientAppointment() ? 7 : 0,
      );
    }

    this.readonlySubscription = this.service.currentReadOnlySubject$.subscribe(
      (readonly) => {
        this.readonly = readonly;
      },
    );

    this.patientCellPhoneSubscription =
      this.service.currentPatientCellPhoneSubject$.subscribe(
        async (cellPhone) => {
          if (this.service.patientId && cellPhone) {
            this.patientView = await this.patientService.getPatientView(
              this.service.patientId,
            );
          }
        },
      );

    this.loading = false;
  }

  async showPhoneFormatDialogIfIsRequired() {
    await this.service.showPhoneFormatDialogIfIsRequired();
  }

  async onPatientSelected(patientSearch: PatientSearch) {
    this.patient = patientSearch;
    await this.service.setPatient(patientSearch.Id);

    this.patientReservationMessageService.showReservationAlertIfRequired(
      patientSearch.Id,
      this.service.showPreAdmissionPatientAppointment(),
      this.service.showPreAdmissionPatientAppointment() ? 7 : 0,
      this.service.showPreAdmissionPatientAppointment() ? 7 : 0,
    );

    if (this.service.validatePhoneRequired()) {
      await this.showPhoneFormatDialogIfIsRequired();
    }
  }
}
